import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";

const ContractorWeeklyInputs = props => {
  const {
    projContractorList,
    cw_weekOf,
    handleChange_cw_weekOf,
    isSaturday,
    cw_selectedContractor,
    handleChange_cw_contractor,
    disabled
  } = props;
  return (
    <div className="card mx-0 mb-2">
      <div className="card-body pb-2">
        <h5 className="mb-3 text-muted">Labor Weekly Report</h5>
        <div className="form-row form-group">
          <label className="col-sm-3 col-form-label my-auto">
            For Week Ending:
          </label>
          <div className="col-sm-4">
            <DatePicker
              customInput={<CustomDatePickerInput />}
              name="cw_weekOf"
              id="cw_weekOf"
              selected={cw_weekOf}
              onChange={value => handleChange_cw_weekOf(value)}
              filterDate={isSaturday}
              placeholderText="Pick a Saturday..."
              disabled={disabled}
            />
          </div>
        </div>
        {/* <div className="form-row form-group">
          <div className="col-sm-3 my-auto">
            <label htmlFor="contractors" className="col-form-label">
              For Contractor:
            </label>
          </div>
          <div className="col-sm-9 my-auto">
            <Select
              name="contractorId"
              id="contractorId"
              value={cw_selectedContractor}
              options={
                projContractorList &&
                projContractorList.map(c => ({
                  value: c.contractorId,
                  label: c.name
                }))
              }
              onChange={value => handleChange_cw_contractor(value)}
              placeholder="(Select a Contractor)"
              isSearchable={false}
              isDisabled={disabled}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ContractorWeeklyInputs;
